import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ScissorOutlinedSvg from "@ant-design/icons-svg/es/asn/ScissorOutlined";
import AntdIcon from "../components/AntdIcon";
var ScissorOutlined = function ScissorOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ScissorOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ScissorOutlined.displayName = 'ScissorOutlined';
}
export default /*#__PURE__*/React.forwardRef(ScissorOutlined);